import React from "react";
import { RouteObject } from "../../interfaces/navigation";
import CongratulationsPage from "../CongratulationsPage";

const FinancingCalculator = React.lazy(() => import("../../containers/FinancingCalculator/EntrypointContainer"));

export const financingCalculatorRoutes: RouteObject[] = [
    {
        path: "/financiar-auto",
        component: <FinancingCalculator />,
        title: "Calculadora de Financiamiento"
    },
    {
        title: "Congratulations",
        path: "/financiar-auto/agradecimiento", 
        component: <CongratulationsPage title={"Consulta recibida."} text={"Un agente Linze se contactará contigo para encontrar la opción de financiamiento más conveniente."} />
    }
];
